import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SprintLogoAvatarComponent } from '@libs/shared/ui/avatar/sprint-logo-avatar.component';
import { UserAvatarComponent } from '@libs/shared/ui/avatar/user-avatar.component';
import {
  ExpertEventNotificationRecord,
  UserGeneralRecord,
} from '@libs/shared/api';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-expert-event-notification-wrapper',
  standalone: true,
  imports: [CommonModule, SprintLogoAvatarComponent, UserAvatarComponent],
  template: `
    <div class="flex flex-row gap-4">
      <!-- Icon -->
      @if (!notification.notifier) {
        <app-sprint-logo-avatar />
      }
      <!-- Image -->
      @if (notification.notifier) {
        <app-user-avatar [user]="notification.notifier" />
      }
      <!-- Title, description & time -->
      <div class="flex w-full flex-col">
        <div class="font-semibold">
          {{ title }}
        </div>
        <ng-content />
        <div class="text-secondary mt-2 text-sm leading-none">
          {{ notification.createdAt | date: 'yyyy-MM-dd (EEE), h:mm a' }}
        </div>
      </div>
    </div>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertEventNotificationWrapperComponent {
  @Input({ required: true }) notification: ExpertEventNotificationRecord;
  @Input({ required: true }) title: string;
}
